import { Col, Container, Form, Row, Button } from "react-bootstrap";
import "./index.css";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Carousel } from "antd";
import dayjs from "dayjs";
import {
  getCategory,
  getState,
  getCityByStateId,
  getVenueByCityId,
} from "../../api/api";
import { useIsMobile } from "../../hooks/useIsMobile";
import { getFeaturedEvent } from "../../api/api";
/**
 * Props:
 * - desktopList?: string[]
 * - mobileList?: string[]
 * - desktopUrl?: string  (fallback)
 * - mobileUrl?: string   (fallback)
 */
const Searchhome = ({
  desktopList = [],
  mobileList = [],
  desktopUrl = "",
  mobileUrl = "",
}) => {
  const isTabletDown = useMediaQuery({ query: "(max-width: 992px)" });
  const isMobile = useIsMobile();
  // Slides según viewport
  const slides = useMemo(() => {
    const listPref = isTabletDown ? mobileList : desktopList;
    const listAlt = isTabletDown ? desktopList : mobileList;
    let arr =
      Array.isArray(listPref) && listPref.length
        ? listPref
        : Array.isArray(listAlt) && listAlt.length
        ? listAlt
        : [];
    if (!arr.length) {
      const urlPref = isTabletDown ? mobileUrl : desktopUrl;
      const urlAlt = isTabletDown ? desktopUrl : mobileUrl;
      arr = [urlPref || urlAlt].filter(Boolean);
    }
    return arr;
  }, [isTabletDown, desktopList, mobileList, desktopUrl, mobileUrl]);

  // Fondo solo si hay 1 imagen (si hay varias, se usa carrusel)
  const heroStyle = useMemo(() => {
    if (slides.length > 1) return {};
    const single = slides[0];
    return single
      ? {
          backgroundImage: `linear-gradient(rgba(0,0,0,.5), rgba(0,0,0,.5)), url(${single})`,
        }
      : {};
  }, [slides]);

  // ---- tu lógica de selects igual ----
  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [city, setCity] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [state, setState] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [venues, setVenues] = useState([]);
  const [selectedVenue, setSelectedVenue] = useState("");
  const navigate = useNavigate();
  // Eventos destacados y slide activo para sincronizar tarjeta con carrusel
  const [featuredEvents, setFeaturedEvents] = useState([]);
  const [activeSlide, setActiveSlide] = useState(0);

  const getcategory = async () => {
    try {
      const res = await getCategory();
      if (res.status === 200) setCategory(res.data.info || []);
    } catch (e) {
      console.error(e);
    }
  };
  const getstate = async () => {
    try {
      const res = await getState();
      if (res.status === 200) setState(res.data.info || []);
    } catch (e) {
      console.error(e);
    }
  };
  const getcity = async (state_id) => {
    try {
      const res = await getCityByStateId({ stateId: state_id });
      if (res.status === 200) setCity(res.data.info || []);
    } catch (e) {
      console.error(e);
    }
  };
  const getvenue = async (city_id) => {
    try {
      const res = await getVenueByCityId({ cityId: city_id });
      if (res.status === 200) setVenues(res.data.info || []);
    } catch (e) {
      console.error(e);
    }
  };

  const search = () => {
    const data = {
      categoryId: selectedCategory,
      stateId: selectedState,
      cityId: selectedCity,
      venueId: selectedVenue,
    };
    if (selectedCategory || selectedState || selectedCity || selectedVenue) {
      navigate(`/event`, { state: data });
    }
  };

  useEffect(() => {
    getcategory();
    getstate();
    (async () => {
      try {
        const res = await getFeaturedEvent();
        const list = Array.isArray(res?.data?.info) ? res.data.info : [];
        setFeaturedEvents(list);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  // Evento a mostrar según el slide activo
  const activeEvent = useMemo(() => {
    if (!featuredEvents || !featuredEvents.length) return null;
    const idx = activeSlide % featuredEvents.length;
    return featuredEvents[idx];
  }, [featuredEvents, activeSlide]);

  return (
    <div
      className="Searchhome pading150"
      style={{ ...heroStyle, position: "relative", overflow: "hidden" }}
    >
      {/* Fondo carrusel si hay más de 1 imagen */}
      {slides.length > 1 && (
        <div className="hero-bg">
          <Carousel autoplay effect="fade" dots autoplaySpeed={5000} speed={600} afterChange={(i) => setActiveSlide(i)}>
            {slides.map((src, i) => (
              <div key={i} className="hero-slide">
                <img src={src} alt={`banner-${i}`} />
              </div>
            ))}
          </Carousel>
          <div className="hero-overlay" />
        </div>
      )}

      {/* CONTENIDO */}
      <Container fluid style={{ position: "relative", zIndex: 1 }}>
        {activeEvent && (
          <div className="hero-info-card">
            <div className="hero-info-title">{activeEvent.name}</div>
            <div className="hero-info-meta">
              <div className="hero-info-line">
                <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 1a1 1 0 0 1 1 1v1h6V2a1 1 0 1 1 2 0v1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1V2a1 1 0 1 1 2 0v1ZM3 7v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7H3Z" fill="#8F99A2"/>
                </svg>
                <span>{dayjs(String(activeEvent.startDate || '').slice(0,10)).format("DD MMM. - YYYY")}</span>
              </div>
              <div className="hero-info-line">
                <svg width="18" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 0C3.86 0 .5 3.36.5 7.5c0 1.63.53 3.12 1.42 4.35.02.03.03.07.05.1l5 7.5c.23.35.62.55 1.03.55.41 0 .8-.2 1.02-.55l5-7.5c.02-.03.03-.07.05-.1.89-1.23 1.43-2.72 1.43-4.35C15.5 3.36 12.14 0 8 0Zm0 10A2.5 2.5 0 1 1 8 5a2.5 2.5 0 0 1 0 5Z" fill="#bac819"/>
                </svg>
                <span>{activeEvent.fulladdress}</span>
              </div>
            </div>
            <div>
              <Button
                className="hero-info-cta"
                onClick={() => navigate(`/event/${activeEvent._id}`, { state: { name: activeEvent.name } })}
              >
                Ver tickets
              </Button>
            </div>
          </div>
        )}
        {/* Texto 
        <Row>
          <Col className="text-orange fw-bold Searchhome1">
            ENCUENTRA UBICACIONES CERCANAS
          </Col>
        </Row>
        <Row>
          <Col
            xl={10}
            lg={10}
            md={12}
            className="fw-bold Searchhome2 text-whiteff"
          >
            ¡Descubre las mejores atracciones, actividades y experiencias!
          </Col>
        </Row>
*/}
        {/* Selects 

        {!isMobile && (
          <Row xs={2} md={2} lg={5} className="Searchhome3">
            <Col>
              <Form.Select
                onChange={(e) => setSelectedCategory(e.target.value)}
                size="lg"
                className="search-event"
                value={selectedCategory}
              >
                <option value="">Categorías</option>
                {category.map((item) => (
                  <option key={item._id || item.id} value={item._id || item.id}>
                    {item.name}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col>
              <Form.Select
                onChange={(e) => {
                  const val = e.target.value;
                  setSelectedState(val);
                  if (!val) {
                    setSelectedCity("");
                    setSelectedVenue("");
                  } else {
                    getcity(val);
                  }
                }}
                value={selectedState}
                size="lg"
                className="search-event"
              >
                <option value="">Provincias</option>
                {state.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.name}
                  </option>
                ))}
              </Form.Select>
            </Col>
            {/*}
          <Col>
            <Form.Select
              onChange={(e) => {
                const val = e.target.value;
                setSelectedCity(val);
                if (!val) setSelectedVenue("");
                else getvenue(val);
              }}
              size="lg"
              value={selectedCity}
              disabled={!selectedState}
              className="search-event"
            >
              <option value="">Ciudad</option>
              {city.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col>
            <Form.Select
              onChange={(e) => setSelectedVenue(e.target.value)}
              size="lg"
              value={selectedVenue}
              disabled={!selectedCity}
              className="search-event ellipsis-select"
            >
              <option value="">Estadio</option>
              {venues.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.address}
                </option>
              ))}
            </Form.Select>
          </Col>

            <Col md={12} xs={12}>
              <button className="buttonsearchevent" onClick={search}>
                <span className="buttonsearcheventtransition"></span>
                <span className="label">Buscar eventos</span>
              </button>
            </Col>
          </Row>
        )}*/}
      </Container>
    </div>
  );
};

export default Searchhome;
